import { render } from "./MotivosCancelamento.vue?vue&type=template&id=277fc7a4&scoped=true"
import script from "./MotivosCancelamento.vue?vue&type=script&lang=js"
export * from "./MotivosCancelamento.vue?vue&type=script&lang=js"

import "./MotivosCancelamento.vue?vue&type=style&index=0&id=277fc7a4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-277fc7a4"]])

export default __exports__